module.exports = __webpack_public_path__ + "img/5_27.c27d6a6b.png";